import React from 'react'
import TranslatedTitle from 'widgets/TranslatedTitle'
import AvatarWrapper from 'ui/partials/AvatarWrapper'
import * as Displays from 'support/displays'
import ModelValueTitle from 'widgets/ModelValueTitle'
import * as UI from 'ui'
import { Link } from '@morningtrain/react-navigation'
import * as Icons from 'ui/icons'
import { Translation } from '@morningtrain/react-translations'
import { PageHeader } from 'ui'
import ManageUserNavigationTabs from 'pages/app/users/partials/ManageUserNavigationTabs'

export default function ManageUserPageHeader ({ create = false, children }) {
  return (
    <>
      <PageHeader title={create ? <TranslatedTitle name='create_title' /> : (
        <div className='flex space-x-4 items-center'>
          <AvatarWrapper large>
            <Displays.Image name='avatar_url' />
          </AvatarWrapper>
          <ModelValueTitle name='name' />
        </div>
      )}
      >
        <UI.ButtonWrap>
          <Link route='app.users.index'>
            <UI.Button>
              <Icons.ArrowLeft className='mr-2' />
              <span><Translation name='actions.back_to_overview' /></span>
            </UI.Button>
          </Link>
          {create && (
            <UI.ButtonWrap>
              {children}
            </UI.ButtonWrap>
          )}
        </UI.ButtonWrap>
      </PageHeader>
      <UI.SpaceBetween>
        {create ? null : (
          <>
            <ManageUserNavigationTabs />
            <UI.ButtonWrap>
              {children}
            </UI.ButtonWrap>
          </>
        )}
      </UI.SpaceBetween>
    </>
  )
}
